import { darkenHex, getPentagonAreas, normalizeCoordinate } from '../helpers';

function DrawPentagonAreaHighlight({
  area,
  show = false,
  fill = 'none',
  filter = '',
  pentagonWidth,
  pentagonHeight,
}) {
  const { points } = area;
  let pointsString = '';
  for (const point of points) {
    pointsString += `${pentagonWidth / 2 + pentagonWidth * (normalizeCoordinate(point[0]) / 100)},${pentagonHeight / 2 + pentagonHeight * (normalizeCoordinate(point[1]) / 100)} `;
  }

  return (
    <polygon
      style={{ pointerEvents: 'none' }}
      points={pointsString}
      strokeWidth={show ? '1' : '0'}
      stroke={show ? darkenHex(fill, 80) : null}
      fill={show ? fill : 'none'}
      filter={show ? filter : ''}
    />
  );
}

function PentagonAreaHighlights({ duvalType, isAreaHighlighted, pentagonWidth, pentagonHeight }) {
  return (
    <g
      name="Area-highlights"
      className="area-highlights"
    >
      <defs>
        <filter
          id="highlightFilter"
          width="120"
          height="120"
        >
          <feFlood
            result="flood"
            floodColor="#ffffff"
            floodOpacity="1"
          ></feFlood>
          <feComposite
            in="flood"
            result="mask"
            in2="SourceGraphic"
            operator="in"
          ></feComposite>
          <feMorphology
            in="mask"
            result="dilated"
            operator="dilate"
            radius="1"
          ></feMorphology>
          <feGaussianBlur
            in="dilated"
            result="blurred"
            stdDeviation="1"
          ></feGaussianBlur>
          <feMerge>
            <feMergeNode in="blurred"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      {getPentagonAreas(duvalType).map((area) => (
        <DrawPentagonAreaHighlight
          area={area}
          show={isAreaHighlighted[area.name.slice(0, 2)]}
          key={area.name}
          fill={area.fill}
          filter="url(#highlightFilter)"
          pentagonWidth={pentagonWidth}
          pentagonHeight={pentagonHeight}
        />
      ))}
    </g>
  );
}

export default PentagonAreaHighlights;
